// src/utils/affiliateTracker.js

const COOKIE_NAME = 'smush_ref';
const COOKIE_DAYS = 30;

/**
 * Parses query parameters and persists referral code to localStorage and cookies
 */
export function initAffiliateTracker() {
  if (typeof window === 'undefined') return null;

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const refParam = urlParams.get('ref') || urlParams.get('via');

    if (refParam) {
      const cleanCode = refParam.trim().toLowerCase().replace(/[^a-z0-9-_]/g, '');
      if (cleanCode.length >= 2) {
        // Save to localStorage
        localStorage.setItem(COOKIE_NAME, cleanCode);

        // Save to Cookie (30 days)
        const maxAge = COOKIE_DAYS * 24 * 60 * 60;
        document.cookie = `${COOKIE_NAME}=${encodeURIComponent(cleanCode)}; path=/; max-age=${maxAge}; SameSite=Lax`;
        
        return cleanCode;
      }
    }
  } catch (err) {
    // Non-fatal error during tracker init
  }

  return getStoredReferralCode();
}

/**
 * Retrieves stored referral code from localStorage or cookies
 */
export function getStoredReferralCode() {
  if (typeof window === 'undefined') return null;

  try {
    // 1. Try localStorage
    const localVal = localStorage.getItem(COOKIE_NAME);
    if (localVal) {
      return localVal.trim().toLowerCase();
    }

    // 2. Try document.cookie
    const match = document.cookie.match(new RegExp('(^|;\\s*)' + COOKIE_NAME + '=([^;]*)'));
    if (match && match[2]) {
      const cookieVal = decodeURIComponent(match[2]).trim().toLowerCase();
      localStorage.setItem(COOKIE_NAME, cookieVal);
      return cookieVal;
    }
  } catch (err) {
    // Fallback to null
  }

  return null;
}
